import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreAllServices } from "../../api/apiServices";
import parseError from "../../utils/parseError";

const useRestoreAllServices = () => {
    const queryClient = useQueryClient();

    const {
        mutate: restoreAllSer,
        isPending: isRestoreAll,
    } = useMutation({
        mutationFn: restoreAllServices,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["services"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore services");
        },
    });

    return {
        restoreAllSer,
        isRestoreAll,
    };
};

export default useRestoreAllServices;
